<template>
    <div>
        <div class="wrapper">
          <nav>
            <input type="radio" name="tab" id="stuHome" value="1" v-on:click="tabchange" checked>
            <input type="radio" name="tab" id="stuInbox" value="2" v-on:click="tabchange">
            <label for="stuHome" class="stuHome press">签到记录</label>
            <label for="stuInbox" class="stuInbox press">学习记录</label>
            <label ></label>
            <label ></label>
            <label ></label>
            <div class="tab">
            </div>
          </nav>
        </div>
        <hr class="pad-top">
    </div>
</template>

<script>
    export default {
        name: "AppBar",
        data () {
          return {

          }
        },
        methods :{
            tabchange(event){
                this.$emit("clicked",event.target.defaultValue);
            }
        }
    }
</script>

<style scoped>
  .wrapper {
    height: 25px;
    width: 60%;
    position: relative;
  }

  .wrapper nav {
    position: relative;
    display: flex;
  }

  .wrapper nav label {
    flex: 1;
    width: 100%;
    z-index: 1;
    padding-bottom: 15px;
    text-align: center;
  }

  .wrapper nav .press {
    cursor: pointer;
  }

  .wrapper nav label a {
    position: relative;
    z-index: -1;
    color: #1d1f20;
    font-size: 20px;
    font-weight: 100;
    text-decoration: none;
    transition: color 0.6s ease;
  }

  .wrapper nav label a i {
    font-size: 25px;
    margin: 0 7px;
  }

  .wrapper nav .tab {
    position: absolute;
    height: 3px;
    width: 20%;
    left: 0;
    bottom: 0;
    z-index: 0;
    border-radius: 50px;
    background: #0171A3;
    transition: 0.2s;
  }

  .wrapper nav #stuInbox:checked~.tab {
    left: 20%;
  }


  .wrapper nav input {
    display: none;
  }

  .pad-top {
    margin-top: 1em;
  }
</style>